import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export type ConfigurationDto = {
  CompanyName?: string;
  CompanyEmail?: string;
  CompanyPhone?: string;
  CompanyUstId?: string;
  CompanyKeyColor?: string;
  CompanyLogoId?: number | string | null;
  CompanyStreet?: string;
  CompanyHouseNumber?: string;
  CompanyZipCode?: string;
  CompanyCity?: string;
  CompanyBank?: string;
  CompanyBankAccount?: string;
  CompanyIban?: string;
  CompanyBic?: string;
  InvoiceNumber_Prefix?: string | null;
  InvoiceNumber_Suffix?: string | null;
  InvoiceNumber_Last?: number | null;
  CreatedAt?: string | null;
  CreatedBy?: string | null;
  EditedAt?: string | null;
  EditedBy?: string | null;
};

export const configurationsApi = createApi({
  reducerPath: "configurationsApi",
  baseQuery: fetchBaseQuery({ baseUrl: "/api" }),
  tagTypes: ["Configurations"],
  endpoints: (b) => ({
    getConfigurations: b.query<{ configurations: ConfigurationDto }, void>({
      query: () => ({ url: "configurations/" }),
      providesTags: [{ type: "Configurations", id: "ROOT" }],
    }),
  }),
});

export const { useGetConfigurationsQuery, useLazyGetConfigurationsQuery } = configurationsApi;
